import { render, staticRenderFns } from "./ConsultaAtencion.vue?vue&type=template&id=dcf47b2e&"
import script from "./ConsultaAtencion.vue?vue&type=script&lang=js&"
export * from "./ConsultaAtencion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports